import { render, staticRenderFns } from "./TheOrderCart.vue?vue&type=template&id=c6ed663a&scoped=true&"
import script from "./TheOrderCart.vue?vue&type=script&lang=js&"
export * from "./TheOrderCart.vue?vue&type=script&lang=js&"
import style0 from "./TheOrderCart.vue?vue&type=style&index=0&id=c6ed663a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ed663a",
  null
  
)

export default component.exports